import { atom } from "recoil";
 
export const loggedInUserState = atom({
  key: "loggedInUserState", // unique ID (with respect to other atoms/selectors)
  default: null, // default value (aka initial value)
});
 